<template>
  <div class="quotes-list">
    <app-toolbar>
      <template #start>
        <app-action-box :title="$t('QUOTES_LIST.FILTERS.TITLE')"
                        @submit="applyViewParams"
                        class="hidden-md-and-up"
                        icon="el-icon-s-operation">
          <quotes-list-filters-fields v-model="viewParams"></quotes-list-filters-fields>
        </app-action-box>

        <app-action-box :title="$t('QUOTES_LIST.SORTS.TITLE')"
                        @submit="applyViewParams"
                        class="sorts-mobile hidden-md-and-up"
                        icon="el-icon-sort">
          <quotes-list-sorts-fields v-model="viewParams"></quotes-list-sorts-fields>
        </app-action-box>
      </template>

      <!--<template #end>
        <el-button icon="el-icon-plus"
                   role="button"
                   round
                   type="primary">
          {{ $t('ACTIONS.ADD') }}
        </el-button>
      </template>-->
    </app-toolbar>

    <el-row :gutter="20"
            type="flex">
      <el-col :lg="6"
              :md="8"
              class="hidden-sm-and-down">
        <app-action-box :title="$t('QUOTES_LIST.FILTERS.TITLE')"
                        @submit="applyViewParams"
                        icon="el-icon-s-operation">
          <quotes-list-filters-fields v-model="viewParams"></quotes-list-filters-fields>
        </app-action-box>

        <app-action-box :title="$t('QUOTES_LIST.SORTS.TITLE')"
                        @submit="applyViewParams"
                        class="sorts-desktop"
                        icon="el-icon-sort">
          <quotes-list-sorts-fields v-model="viewParams"></quotes-list-sorts-fields>
        </app-action-box>
      </el-col>

      <el-col :infinite-scroll-disabled="isLoading"
              v-infinite-scroll="goToNextPage"
              v-loading="isLoading">
        <app-alert :description="$t('QUOTES_LIST.ERRORS.GET.DESCRIPTION')"
                   :label="$t('QUOTES_LIST.ERRORS.GET.LABEL')"
                   type="error"
                   v-if="isInError">
        </app-alert>

        <app-alert :description="$t('QUOTES_LIST.ERRORS.NOTHING_TO_SEE.DESCRIPTION')"
                   :label="$t('QUOTES_LIST.ERRORS.NOTHING_TO_SEE.LABEL')"
                   v-else-if="!isLoading && quotes.length === 0">
        </app-alert>

        <div v-else-if="quotes.length !== 0">
          <div :key="`grouped_quotes_${key}`"
               class="grouped-quotes"
               v-for="(quotes, key) in groupedQuotes">
            <el-divider>{{ key }}</el-divider>

            <quotes-list-resume :key="`quote_${quote.id}`"
                                :value="quote"
                                @click.native="goToQuotesDetailView(quote)"
                                v-for="quote in quotes">
            </quotes-list-resume>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AppActionBox from '@/components/action-box/ActionBox'
import AppAlert from '@/components/alert/Alert'
import AppToolbar from '@/components/toolbar/Toolbar'
import quotesService from '@/services/quotesService'
import QuotesListFiltersFields from './components/QuotesListFiltersFields'
import QuotesListResume from './components/QuotesListResume'
import QuotesListSortsFields from './components/QuotesListSortsFields'

export default {
  name: 'QuotesList',
  components: {
    QuotesListSortsFields,
    AppActionBox,
    QuotesListFiltersFields,
    AppAlert,
    AppToolbar,
    QuotesListResume
  },
  data () {
    return {
      isLoading: false,
      isInError: false,
      pagination: {},
      viewParams: {},
      quotes: [],
      groupedQuotes: {}
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.initViewParams(to.query.q)
      vm.getQuotes()
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.initViewParams(to.query.q)
    this.getQuotes()
    next()
  },
  methods: {
    initViewParams (viewParamsFromURL) {
      const defaultViewParams = {
        equipmentTypes: [],
        packagingTypes: [],
        pickupRegions: [],
        deliveryRegions: [],
        responded: true,
        manageable: true,
        sort: 'pickup.earliestDate',
        page: 1
      }

      if (viewParamsFromURL) {
        this.viewParams = Object.assign(defaultViewParams, JSON.parse(atob(viewParamsFromURL)))
      } else {
        this.viewParams = defaultViewParams
      }
    },
    async getQuotes () {
      this.isLoading = true

      try {
        const data = await quotesService.findAll(this.viewParams)
        this.quotes = data.quotes
        this.pagination = data.pagination

        const groupedQuotes = {}

        this.quotes.forEach(quote => {
          const date = this.$options.filters.date(quote[this.viewParams.sort], 'v')

          if (groupedQuotes[date] === undefined) {
            groupedQuotes[date] = []
          }

          groupedQuotes[date].push(quote)
        })

        this.groupedQuotes = groupedQuotes
        this.isLoading = false
      } catch (error) {
        this.isInError = true
        this.isLoading = false
        throw error
      }
    },
    applyViewParams () {
      this.quotes = []
      this.groupedQuotes = {}
      this.refreshQuotesListView()
    },
    refreshQuotesListView () {
      this.$router.replace({
        name: 'quotes-list',
        query: { q: btoa(JSON.stringify(this.viewParams)) }
      })
    },
    goToNextPage () {
      if (this.pagination.currentPage < this.pagination.totalPages) {
        this.viewParams.page++
        this.refreshQuotesListView()
      }
    },
    goToQuotesDetailView (quote) {
      this.$router.push({ name: 'quotes-detail', params: { id: quote.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.quotes-list {
  .quotes-list-resume + .quotes-list-resume,
  .sorts-desktop {
    margin-top: 0.5rem
  }

  .sorts-mobile {
    margin-left: 0.5rem;
  }
}
</style>
